import {
  carlosCaminhaImg,
  javamMachadoImg,
  joaoPauloPordeusImg,
  joaquimBentoImg,
  joseMariaImg,
  leornardoOliveriaImg,
  victorEvangelistaImg,
  yuriLenonImg,
  eduardoDuarteImg,
  iagoCastroImg,
  joseSerafimImg,
  pauloRobertoImg,
  edioMarreiroImg,
  julioOliveiraImg,
  rafaelSombraImg,
  tiagoLinsImg,
  libraryLsbdImg,
  meetingLsbdImg,
  serverLsbdImg,
  workplaceLsbdImg
} from 'src/assets/images'
import hubIcon from 'src/assets/icons/linesResearch/hub-icon.svg'
import dataCenterIcon from 'src/assets/icons/laboratoryInfo/data-center-icon.svg'
import projectManagementIcon from 'src/assets/icons/laboratoryInfo/project-management-icon.svg'
import testIcon from 'src/assets/icons/laboratoryInfo/test-icon.svg'
import userGroupsIcon from 'src/assets/icons/laboratoryInfo/user-groups-icon.svg'
import cafeIcon from 'src/assets/icons/laboratoryInfo/cafe-icon.svg'
import bookStackIcon from 'src/assets/icons/laboratoryInfo/book-stack-icon.svg'

export const TEACHERS_LIST = [
  {
    src: javamMachadoImg,
    name: 'Prof. Dr. Javam \n Machado',
    position: 'laboratory.coordinator',
    lattesUrl: 'http://lattes.cnpq.br/9884980518986225'
  },
  {
    src: carlosCaminhaImg,
    name: 'Prof. Dr. Carlos \n Caminha',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/4380023778677961'
  },
  {
    src: joaoPauloPordeusImg,
    name: 'Prof. Dr. João Paulo \n Pordeus',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/9553770402705512'
  },
  {
    src: joaquimBentoImg,
    name: 'Prof. Dr. Joaquim \n Cavalcante',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/0866205347972203'
  },
  {
    src: joseMariaImg,
    name: 'Prof. Dr. José Maria \n Monteiro',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/9790693300026949'
  },
  {
    src: leornardoOliveriaImg,
    name: 'Prof. Dr. Leonardo \n Oliveira',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/2880668102587861'
  },
  {
    src: victorEvangelistaImg,
    name: 'Prof. Dr. Victor \n Evangelista',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/9895446406302202'
  },
  {
    src: yuriLenonImg,
    name: 'Prof. Dr. Yuri \n Lenon',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/9965458635397780'
  }
]

export const STAFF_RESEARCH_LIST = [
  {
    src: eduardoDuarteImg,
    name: 'Dr. Eduardo Duarte \n',
    title: 'laboratory.post-doc',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/9088370074451475'
  },
  {
    src: iagoCastroImg,
    name: 'Dr. Iago Castro \n',
    title: 'laboratory.post-doc',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/5223391736264519'
  },
  {
    src: joseSerafimImg,
    name: 'Dr. José Serafim \n Costa',
    title: 'laboratory.post-doc',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/5014333194028146'
  },
  {
    src: pauloRobertoImg,
    name: 'Dr. Paulo Roberto \n Amora',
    title: 'laboratory.post-doc',
    position: 'laboratory.researcher',
    lattesUrl: 'http://lattes.cnpq.br/3445857613394275'
  }
]

export const PROJECTIONIST_LIST = [
  {
    src: edioMarreiroImg,
    name: 'Edio Marreiro',
    position: 'laboratory.project-manager',
    lattesUrl: 'http://lattes.cnpq.br/4753518546580618'
  },
  {
    src: julioOliveiraImg,
    name: 'Julio Oliveira',
    position: 'laboratory.project-manager',
    lattesUrl: ''
  },
  {
    src: rafaelSombraImg,
    name: 'Rafael Sombra',
    position: 'laboratory.project-manager',
    lattesUrl: ''
  },
  {
    src: tiagoLinsImg,
    name: 'Tiago Lins',
    position: 'laboratory.project-manager',
    lattesUrl: ''
  }
]

export const STRUCTURE_LIST = [
  {
    src: hubIcon,
    text: 'laboratory.infrastructure-room'
  },
  {
    src: dataCenterIcon,
    text: 'laboratory.data-center'
  },
  {
    src: projectManagementIcon,
    text: 'laboratory.project-management'
  },
  {
    src: testIcon,
    text: 'laboratory.quality-and-testing-area'
  },
  {
    src: userGroupsIcon,
    text: 'laboratory.meeting-room'
  },
  {
    src: cafeIcon,
    text: 'laboratory.coffee-area'
  },
  {
    src: bookStackIcon,
    text: 'laboratory.own-library'
  }
]

export const STRUCTURE_IMG_LIST = [
  {
    src: libraryLsbdImg,
    alt: 'laboratory.library-lsbd-alt'
  },
  {
    src: meetingLsbdImg,
    alt: 'laboratory.meeting-lsbd-alt'
  },
  {
    src: serverLsbdImg,
    alt: 'laboratory.server-lsbd-alt'
  },
  {
    src: workplaceLsbdImg,
    alt: 'laboratory.workplace-lsbd-alt'
  }
]
